import React, { PropsWithChildren } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { DefaultTheme, ThemeProvider } from 'styled-components';
import { loadConfigRequest } from '../store/config/actions';
import Theme from './themes/light';
type Props = {
  theme: DefaultTheme;
  loadConfigRequest: typeof loadConfigRequest;
};

const ConnectedThemeProvider = ({
  children,
  theme,
  loadConfigRequest,
}: PropsWithChildren<Props>) => {
  React.useEffect(() => {
    loadConfigRequest();
  }, [loadConfigRequest]);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export interface AssessoriaThemeConfigs {
  assessoriaPalette: string;
  darkColor: string;
  secondaryDarkColor: string;
  lightColor: string;
  linkColor: string;
  fontColor: string;
  userDataColor: string;
  hasBorder: string;
  headerColor: string;
  footerColor: string;
  borderRadius: string;
  nomeFont: string;
  footerFontColor: string;
  radiusCards: string;
  radiusBotoesContato: string;
}

const mapStateToProps = (state: ApplicationState) => {
  const assessoriaThemeConfigs: AssessoriaThemeConfigs = {
    assessoriaPalette: state.config.assessoriaPalette,
    darkColor: state.config.corEscura,
    secondaryDarkColor: state.config.corEscuraSecundaria,
    lightColor: state.config.corClara,
    linkColor: state.config.homePageLinkColor,
    userDataColor: state.config.corDadosUsuario,
    fontColor: state.config.homePageFontColor,
    hasBorder: state.config.usaBordaHomePageCpfInput,
    headerColor: state.config.corHeader,
    footerColor: state.config.corFooter,
    borderRadius: state.config.radiusButton,
    nomeFont: state.config.nomeFont,
    footerFontColor: state.config.corFontFooter,
    radiusCards: state.config.radiusCards,
    radiusBotoesContato: state.config.radiusBotoesContato,
  };

  const theme: AssessoriaThemeConfigs = (assessoriaThemeConfigs.assessoriaPalette &&
    assessoriaThemeConfigs) || {
    ...assessoriaThemeConfigs,
    assessoriaPalette: '#3C50E0',
  };

  return {
    theme: Theme(theme),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      loadConfigRequest,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConnectedThemeProvider);
